/* eslint-disable react-hooks/exhaustive-deps */
import {
  updateSalesInvoiceApi,
  getAllSalesContractApi,
  getAllSalesInvoiceBillApi,
  getSalesInvoiceDetailsByIdApi,
  getSalesContractsByBuyerApi,
} from "../../../services/_sales";
import {
  myDocumentsInputInitialValues,
  salesInvoiceInitialValues,
  SalesInvoiceProducts,
  salesInvoiceProductValues,
  salesInvoiceValidationSchema,
} from "./helpers/SalesInvoiceHelper";
import moment from "moment";
import { Formik, Form, FieldArray } from "formik";
import { getAllChaApi } from "../../../services/_cha";
import { useCallback, useEffect, useRef, useState } from "react";
import { getAllPortsApi } from "../../../services/_port";
import { useNavigate, useParams } from "react-router-dom";
import BasicFields from "./sales-invoice-form/BasicFields";
import ActionFields from "./sales-invoice-form/ActionFields";
import { getBuyerNameListApi } from "../../../services/_buyer";
import ProductFields from "./sales-invoice-form/ProductFields";
import { getAllLogisticApi } from "../../../services/_logistic";
import { getAllDocumentApi } from "../../../services/_document";
import ShipmentFields from "./sales-invoice-form/ShipmentFields";
import ContainerFields from "./sales-invoice-form/ContainerFields";
import { getProductNameListApi } from "../../../services/_product";
import { errorToast, successToast } from "../../../components/Toast";
import MyDocumentsFields from "./sales-invoice-form/MyDocumentsFields";
import OtherDocumentsFields from "./sales-invoice-form/OtherDocumentsFields";
import { DocumentType, SelfDocuments } from "../../../components/Enums";
import { getAllPackingTypesApi } from "../../../services/_packingTypes";
import { getAllUnitsApi } from "../../../services/_unit";
import AddUnitModal from "../../../components/modal/AddUnit";
import AddPackingType from "../../../components/modal/AddPackingType";
import BillFields from "./sales-invoice-form/BillFields";
import { getAllSealNumberNameListApi } from "../../../services/_sealNumber";
import AddProductModal from "../../../components/modal/AddProduct";
import AddDocumentModal from "../../../components/modal/AddDocument";
import AddLogisticModal from "../../../components/modal/AddLogistics";
import AddChaModal from "../../../components/modal/AddCha";
import AddPortModal from "../../../components/modal/AddPort";
import AddBillTypeModal from "../../../components/modal/AddBillType";
import TotalSection from "./sales-invoice-form/TotalSection";
import {
  calculate,
  getSalesContractDetailsWithRemainingQty,
  handleSalesInvoiceCalculation,
  n,
} from "./helpers/SalesInvoiceHelperFunction";
import { getPermissions } from "../../../context/AuthContext";
import { getNotifyPartyNameListApi } from "../../../services/_notifyParty";
import AddNotifyPartyModal from "../../../components/modal/AddNotifyParty";
import SupplierProducts from "./sales-invoice-form/SupplierProducts";
import { getSupplierNameListApi } from "../../../services/_supplier";
import AddSealNumberModal from "../../../components/modal/AddSealNumber";

const EditSalesInvoice = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const permissions = getPermissions();
  const [noOfContainers, setNoOfContainers] = useState("");
  const [isShowContainerButton, setIsShowContainerButton] = useState(true);
  const [isShowMyDocumentButton, setIsShowMyDocumentButton] = useState(true);
  const [salesContractList, setSalesContractList] = useState([]);
  const [billList, setBillList] = useState([]);
  const [buyerList, setBuyerList] = useState([]);
  const [notifyPartyList, setNotifyPartyList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [logisticList, setLogisticList] = useState([]);
  const [chaList, setChaList] = useState([]);
  const [portList, setPortList] = useState([]);
  const [sealNumbersList, setSealNumbersList] = useState<any[]>([]);
  const [myDocumentList, setMyDocumentList] = useState([]);
  const [documentList, setDocumentList] = useState([]);
  const [submitLoader, setSubmitLoader] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<any>(
    salesInvoiceInitialValues,
  );
  const [filePondDocuments, setFilePondDocuments] = useState([]);
  const [filePondBills, setFilePondBills] = useState([]);
  const [unitList, setUnits] = useState<any[]>([]);
  const [packingType, setPackingType] = useState<any[]>([]);
  const [addUnitModalStatus, setAddUnitModalStatus] = useState(false);
  const [addPackingTypeModalStatus, setAddPackingTypeModalStatus] =
    useState(false);
  const [addProductModalStatus, setAddProductModalStatus] = useState(false);
  const [addDocumentModalStatus, setAddDocumentModalStatus] = useState(false);
  const [addLogisticModalStatus, setAddLogisticModalStatus] = useState(false);
  const [addChaModalStatus, setAddChaModalStatus] = useState(false);
  const [addNotifyPartyModalStatus, setAddNotifyPartyModalStatus] =
    useState(false);
  const [addPortModalStatus, setAddPortModalStatus] = useState(false);
  const [addBillTypeModalStatus, setAddBillTypeModalStatus] = useState(false);

  const [salesContractData, setSalesContractData] = useState<any>([]);
  const [filteredProductList, setFilteredProductList] = useState<any[]>([]);
  const [remainingQtyList, setRemainingQtyList] = useState<{
    [product_id: string]: number;
  }>({});
  const [rowPurchaseOrders, setRowPurchaseOrders] = useState<{
    [key: number]: any[];
  }>({});
  const [supplierList, setSupplierList] = useState<any[]>([]);
  const [supplierProductsQtyData, setSupplierProductsQtyData] = useState<any>(
    [],
  );
  const [addSealNumberModalStatus, setAddSealNumberModalStatus] =
    useState(false);
  const [selectedSealContainer, setSelectedSealContainer] = useState<{
    productIndex: number | null;
    containerIndex: number | null;
  }>({ productIndex: null, containerIndex: null });

  useEffect(() => {
    if (!id) {
      navigate("/sales-invoice-list");
    }
  });
  const formikSetFieldValueRef = useRef<any>(null);
  const fetchInitialData = async () => {
    const result: any = await getSalesInvoiceDetailsByIdApi(id as string);
    if (result.isSuccess) {
      const filterOtherDocuments = result?.data?.other_documents?.map(
        (x: any) => {
          x.existing_files = x.files;
          x.files = [];
          x.remove_files = [];
          return x;
        },
      );

      const filterBills = result?.data?.bills?.map((x: any) => {
        x.existing_files = x.files;
        x.files = [];
        x.remove_files = [];
        return x;
      });

      const filterMyDocuments = result?.data?.my_documents?.map(
        (x: any) => x.document_id,
      );

      const transformedData = {
        ...salesInvoiceInitialValues,
        sales_contract_ids: result?.data?.sales_contract_ids || [],
        buyer_id: result?.data?.buyer_id || "",
        invoice_no: result?.data?.invoice_no || "",
        invoice_date: result?.data?.invoice_date
          ? new Date(result?.data?.invoice_date)
          : null,
        logistic_id: result?.data?.logistic_id || "",
        cha_id: result?.data?.cha_id || "",
        is_notify_party: result?.data?.is_notify_party || false,
        notify_party_id: result?.data?.notify_party_id || "",
        status: result?.data?.status,

        sales_invoice_products: (result.data.sales_invoice_products || []).map(
          (p: any) => ({
            ...p,
            sales_contract_id: p.sales_contract?.id || p.sales_contract_id,
            product_contract_key: `${p.product_id}_${p.sales_contract?.id || p.sales_contract_id}`,
          }),
        ),

        total_quantity: result?.data?.total_quantity || "",
        total_amount: result?.data?.total_amount || "",
        exchange_rate: result?.data?.exchange_rate || "",
        total_taxable_amount_inr: result?.data?.total_taxable_amount_inr || "",
        igst_percentage: result?.data?.igst_percentage || "",
        total_igst_amount_inr: result?.data?.total_igst_amount_inr || "",
        commission_rate: result?.data?.commission_rate || "",
        commission_amount: result?.data?.commission_amount || "",
        total_no_of_bags: result?.data?.total_no_of_bags || "",
        total_net_weight: result?.data?.total_net_weight || "",
        total_gross_weight: result?.data?.total_gross_weight || "",
        sales_invoice_supplier_products: (
          result?.data.sales_invoice_supplier_products ?? []
        ).map((supplierProduct: any) => {
          return {
            ...supplierProduct,
            supplier_id: supplierProduct?.purchase?.supplier_id || null,
          };
        }),
        container_size: result?.data?.container_size || "",
        origin_port_id: result?.data?.origin_port_id || "",
        port_of_loading_code: result?.data?.port_of_loading_code || "",
        etd: result?.data?.etd ? new Date(result?.data?.etd) : null,
        destination_port: result?.data?.destination_port || "",
        eta: result?.data?.eta ? new Date(result?.data?.eta) : null,
        pre_carriage_by: result?.data?.pre_carriage_by || "",
        vessel_no: result?.data?.vessel_no || "",
        delivery_term: result?.data?.delivery_term || "",
        payment_term: result?.data?.payment_term || "",
        bl_no: result?.data?.bl_no || "",

        container: result?.data?.containers || [],
        my_documents: filterMyDocuments || [],
        my_documents_inputs: {
          ...myDocumentsInputInitialValues,
          ...result?.data?.my_documents_inputs,
        },
        other_documents: filterOtherDocuments || [],
        bills: filterBills || [],
      };
      if (result?.data?.containers.length) {
        setIsShowContainerButton(false);
      }
      if (result?.data?.my_documents.length) {
        setIsShowMyDocumentButton(false);
      }
      // setInitialValues(transformedData);

      const contractIds = result?.data?.sales_contract_ids || [];

      let allContracts: any[] = [];
      let productRemaining: any = {};

      for (const contractId of contractIds) {
        const data = await getSalesContractDetailsWithRemainingQty(
          contractId,
          id?.toString(),
        );

        if (!data) continue;

        const { sales_contract, productWiseRemainingQty } = data;

        allContracts.push(sales_contract);

        Object.assign(productRemaining, productWiseRemainingQty);
      }

      setSalesContractData(allContracts);
      setRemainingQtyList(productRemaining);

      const productMap: any = {};

      allContracts.forEach((contract) => {
        contract.sales_contract_product.forEach((p: any) => {
          const key = `${p.product_id}_${contract.id}`;

          // allow products already used in invoice
          const existing = transformedData.sales_invoice_products?.find(
            (inv: any) =>
              inv.product_id === p.product_id &&
              (inv.sales_contract?.id || inv.sales_contract_id) === contract.id,
          );

          if (!productRemaining[key] && !existing) return;

          productMap[key] = {
            product_id: p.product_id,
            contract_id: contract.id,
            contract_no: contract.contract_no,
            products: {
              name: p.products?.name,
            },
          };
        });
      });

      const invoiceProducts = transformedData.sales_invoice_products || [];

      invoiceProducts.forEach((p: any) => {
        const contractId = p.sales_contract?.id || p.sales_contract_id;
        const key = `${p.product_id}_${contractId}`;

        if (!productMap[key]) {
          const contract = allContracts.find((c: any) => c.id === contractId);

          productMap[key] = {
            product_id: p.product_id,
            contract_id: contractId,
            contract_no: contract?.contract_no,
            products: {
              name:
                p.products?.name ||
                contract?.sales_contract_product?.find(
                  (sp: any) => sp.product_id === p.product_id,
                )?.products?.name,
            },
          };
        }
      });

      setFilteredProductList(Object.values(productMap));

      setInitialValues({
        ...transformedData,
        sales_invoice_products: invoiceProducts.length
          ? invoiceProducts
          : [salesInvoiceProductValues],
      });
      const buyerId = result?.data?.buyer_id;

      if (buyerId) {
        const contracts = await getSalesContractsByBuyerApi(buyerId);

        if (contracts?.isSuccess && "data" in contracts) {
          setSalesContractList(contracts.data);
        }
      }
      const allBills: any = await getAllSalesInvoiceBillApi();
      if (allBills.isSuccess) {
        setBillList(allBills.data);
      }
      const allBuyers: any = await getBuyerNameListApi();
      if (allBuyers.isSuccess) {
        setBuyerList(allBuyers.data);
      }
      const allProducts: any = await getProductNameListApi();
      if (allProducts.isSuccess) {
        setProductList(allProducts.data);
      }

      const allLogistics: any = await getAllLogisticApi();
      if (allLogistics.isSuccess) {
        setLogisticList(allLogistics.data);
      }
      const allCha: any = await getAllChaApi();
      if (allCha.isSuccess) {
        setChaList(allCha.data);
      }
      const allNotifyParties: any = await getNotifyPartyNameListApi();
      if (allNotifyParties.isSuccess) {
        setNotifyPartyList(allNotifyParties.data);
      }
      const allPorts: any = await getAllPortsApi();
      if (allPorts.isSuccess) {
        setPortList(allPorts.data);
      }
      const sealNumbersList: any = await getAllSealNumberNameListApi(
        `Unused_seal_numbers=true&invoice_id=${result.data.id}`,
      );
      if (sealNumbersList.isSuccess) {
        setSealNumbersList(sealNumbersList.data);
      }
      const allDocuments: any = await getAllDocumentApi();
      if (allDocuments.isSuccess) {
        setDocumentList(allDocuments.data);
        const myDocuments = allDocuments.data.filter(
          (x: any) => x.type === DocumentType.SELF,
        );
        setMyDocumentList(myDocuments);
      }

      const allSuppliers: any = await getSupplierNameListApi();
      if (allSuppliers.isSuccess) {
        setSupplierList(allSuppliers.data);
      }

      const getPackingType: any = await getAllPackingTypesApi();
      if (getPackingType.isSuccess) {
        setPackingType(getPackingType.data);
      }
    } else {
      errorToast(result.message);
    }
  };

  useEffect(() => {
    fetchInitialData();
  }, []);

  const closeAddUnitModal = () => {
    setAddUnitModalStatus(false);
  };

  const closePackingTypeModal = () => {
    setAddPackingTypeModalStatus(false);
  };

  const closeAddProductModal = () => {
    setAddProductModalStatus(false);
  };

  const closeAddDocumentModal = () => {
    setAddDocumentModalStatus(false);
  };

  const closeAddLogisticModal = () => {
    setAddLogisticModalStatus(false);
  };

  const closeAddChaModal = () => {
    setAddChaModalStatus(false);
  };

  const closeAddNotifyPartyModal = () => {
    setAddNotifyPartyModalStatus(false);
  };

  const closeAddPortModal = () => {
    setAddPortModalStatus(false);
  };

  const closeAddBillTypeModal = () => {
    setAddBillTypeModalStatus(false);
  };

  const closeAddSealNumberModal = () => {
    setAddSealNumberModalStatus(false);
  };
  const getCommonValue = (contracts: any[], key: string) => {
    const values = contracts
      .map((c) => c[key])
      .filter((v) => v !== null && v !== undefined && v !== "");

    if (!values.length) return "";

    const first = values[0];

    const allSame = values.every((v) => v === first);

    return allSame ? first : "";
  };
  const handleSalesContractChange = useCallback(
    async (contractIds: string[], setFieldValue: any, values: any) => {
      if (!contractIds?.length) {
        setFilteredProductList(productList);
        setSalesContractData([]);
        setRemainingQtyList({});
        setFieldValue("sales_invoice_products", []);
        return;
      }

      let allContracts: any[] = [];
      let productRemaining: any = {};
      let productMap: any = {};
      let invoiceProducts: any[] = [];

      for (const contractId of contractIds) {
        const result = await getSalesContractDetailsWithRemainingQty(
          contractId,
          id?.toString(),
        );

        if (!result) continue;

        const { sales_contract, productWiseRemainingQty } = result;

        allContracts.push(sales_contract);

        sales_contract.sales_contract_product.forEach((p: any) => {
          const key = `${p.product_id}_${sales_contract.id}`;
          const remaining = productWiseRemainingQty[key];

          if (!remaining || remaining <= 0) return;

          productRemaining[key] = remaining;

          productMap[key] = {
            product_id: p.product_id,
            contract_id: sales_contract.id,
            contract_no: sales_contract.contract_no,
            products: { name: p.products?.name },
          };

          const existingProduct = values.sales_invoice_products?.find(
            (prod: any) =>
              prod.product_id === p.product_id &&
              prod.sales_contract_id === sales_contract.id,
          );

          const quantity = existingProduct
            ? existingProduct.quantity
            : remaining;

          invoiceProducts.push({
            product_id: p.product_id,
            sales_contract_id: sales_contract.id,
            price: p.price,
            quantity,
            total_amount: p.price * quantity,
            no_of_containers: p.no_of_containers,
            container_load: p.container_load,
            packing_type_id: p.packing_type_id,
            no_of_bags: p.no_of_bags,
            packing_net_weight: p.packing_net_weight,
            total_net_weight: calculate(
              n(p.no_of_bags) * n(p.packing_net_weight),
            ),
            packing_gross_weight: p.packing_gross_weight,
            total_gross_weight: calculate(
              n(p.no_of_bags) * n(p.packing_gross_weight),
            ),
          });
        });
      }

      setSalesContractData(allContracts);
      setRemainingQtyList(productRemaining);
      setFilteredProductList(Object.values(productMap));

      // shipment background logic
      const originPort = getCommonValue(allContracts, "port_of_loading_id");
      const destinationPort = getCommonValue(allContracts, "final_destination");
      const deliveryTerm = getCommonValue(allContracts, "delivery_terms");
      const paymentTerm = getCommonValue(allContracts, "payment_terms");

      setFieldValue("origin_port_id", originPort);
      setFieldValue("destination_port", destinationPort);
      setFieldValue("delivery_term", deliveryTerm);
      setFieldValue("payment_term", paymentTerm);

      const validProductKeys = invoiceProducts.map(
        (p) => `${p.product_id}_${p.sales_contract_id}`,
      );

      const updatedContainers = (values.container || []).filter((c: any) =>
        validProductKeys.includes(`${c.product_id}_${c.sales_contract_id}`),
      );

      setFieldValue("container", updatedContainers);

      setFieldValue("sales_invoice_products", invoiceProducts);

      handleSalesInvoiceCalculation(
        "both",
        { ...values, sales_invoice_products: invoiceProducts },
        setFieldValue,
      );
    },
    [productList],
  );

  // Set remaining quantity data and product data from sales contract
  const handleProductChange = (
    index: number,
    value: string,
    values: any,
    setFieldValue: any,
  ) => {
    if (!value) {
      setFieldValue(`sales_invoice_products[${index}]`, {
        ...salesInvoiceProductValues,
      });

      // also remove containers linked to this product
      const updatedContainers = (values.container || []).filter(
        (c: any, i: number) => i !== index,
      );
      setFieldValue("container", updatedContainers);

      handleSalesInvoiceCalculation("both", values, setFieldValue);
      return;
    }

    const [productId, contractId] = value.split("_");

    let productData: any = null;

    salesContractData.forEach((contract: any) => {
      if (contract.id === contractId) {
        const found = contract.sales_contract_product.find(
          (p: any) => p.product_id === productId,
        );

        if (found) productData = found;
      }
    });

    if (!productData) return;

    const remainingQty = remainingQtyList[`${productId}_${contractId}`] || 0;

    const updatedProduct = {
      product_id: productId,
      sales_contract_id: contractId,
      price: productData.price,
      quantity: remainingQty,
      total_amount: productData.price * remainingQty,
      no_of_containers: productData.no_of_containers,
      container_load: productData.container_load,
      packing_type_id: productData.packing_type_id,
      no_of_bags: productData.no_of_bags,
      packing_net_weight: productData.packing_net_weight,
      total_net_weight: calculate(
        n(productData.no_of_bags) * n(productData.packing_net_weight),
      ),
      packing_gross_weight: productData.packing_gross_weight,
      total_gross_weight: calculate(
        n(productData.no_of_bags) * n(productData.packing_gross_weight),
      ),
    };

    setFieldValue(`sales_invoice_products[${index}]`, updatedProduct);

    values.sales_invoice_products[index] = updatedProduct;

    handleSalesInvoiceCalculation("both", values, setFieldValue);
  };

  const handleFileChange = useCallback(
    (fileItems: any, setFieldValue: any, inputKey: string) => {
      const files = fileItems
        .map((fileItem: any) => {
          if (fileItem?.file) {
            return {
              fileName: fileItem.file.name,
              fileData: fileItem.getFileEncodeDataURL(),
            };
          }
          return null;
        })
        .filter(Boolean);
      setFieldValue(inputKey, files);
    },
    [],
  );

  const handleSubmit = async (values: any, { resetForm }: any) => {
    const contractIds = values.sales_contract_ids || [];

    const usedContracts = (values.sales_invoice_products || []).map(
      (p: any) => p.sales_contract_id,
    );

    const unusedContracts = contractIds.filter(
      (id: string) => !usedContracts.includes(id),
    );

    // convert IDs → contract numbers
    const unusedContractNos = salesContractData
      .filter((c: any) => unusedContracts.includes(c.id))
      .map((c: any) => c.contract_no);

    if (unusedContractNos.length > 0) {
      errorToast(
        `Please add at least one product for contract ${unusedContractNos.join(", ")}`,
      );
      return;
    }
    values.invoice_date = moment(values.invoice_date).format("YYYY-MM-DD");
    values.etd = values?.etd
      ? moment(values.etd).format("YYYY-MM-DD HH:mm:ss")
      : null;
    values.eta = values?.eta
      ? moment(values.eta).format("YYYY-MM-DD HH:mm:ss")
      : null;
    values.total_amount = parseFloat(values.total_amount);
    setSubmitLoader(true);
    const result: any = await updateSalesInvoiceApi(id as string, values);
    if (result.isSuccess) {
      setSubmitLoader(false);
      setIsShowContainerButton(false);
      setIsShowMyDocumentButton(false);
      successToast(result.message);
      resetForm({ values: initialValues });
      navigate(`/sales-invoice-list`);
    } else {
      setSubmitLoader(false);
      errorToast(result.message);
    }
    return;
  };

  return (
    <>
      <div className="card">
        <div className="card-header pb-0 d-flex justify-content-between">
          <div>
            <h5>Edit Commercial Invoice</h5>
          </div>
        </div>
        <div className="card-body">
          <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={salesInvoiceValidationSchema}
            onSubmit={handleSubmit}
          >
            {({
              values,
              handleChange,
              setFieldValue,
              errors,
              touched,
              resetForm,
              setFieldError,
            }) => {
              formikSetFieldValueRef.current = setFieldValue;
              return (
                <Form className="dt_adv_search">
                  <div className="row g-3">
                    <BasicFields
                      salesContractList={salesContractList}
                      buyerList={buyerList}
                      logisticList={logisticList}
                      chaList={chaList}
                      notifyPartyList={notifyPartyList}
                      setAddLogisticModalStatus={setAddLogisticModalStatus}
                      setAddChaModalStatus={setAddChaModalStatus}
                      setAddNotifyPartyModalStatus={
                        setAddNotifyPartyModalStatus
                      }
                      values={values}
                      setFieldValue={setFieldValue}
                      resetForm={resetForm}
                      handleChange={handleChange}
                      handleSalesContractChange={handleSalesContractChange}
                      permissions={permissions}
                    />

                    <div>
                      <label
                        htmlFor="products"
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Add Products: <span className="text-danger">*</span>
                      </label>
                      <div>
                        <FieldArray name="sales_invoice_products">
                          {({ remove }) => (
                            <>
                              {(values.sales_invoice_products ?? []).map(
                                (item: SalesInvoiceProducts, index: number) => (
                                  <ProductFields
                                    key={index}
                                    index={index}
                                    item={item}
                                    remove={remove}
                                    unitList={unitList}
                                    productList={filteredProductList}
                                    packingType={packingType}
                                    values={values}
                                    setFieldValue={setFieldValue}
                                    handleChange={handleChange}
                                    setAddUnitModalStatus={
                                      setAddUnitModalStatus
                                    }
                                    setAddPackingTypeModalStatus={
                                      setAddPackingTypeModalStatus
                                    }
                                    setAddProductModalStatus={
                                      setAddProductModalStatus
                                    }
                                    handleProductChange={handleProductChange}
                                    remainingQtyList={remainingQtyList}
                                    setFieldError={setFieldError}
                                    errors={errors}
                                    permissions={permissions}
                                  />
                                ),
                              )}
                              <div className="row mb-1 g-1 px- col-12 col-sm-6 col-lg-3">
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={() => {
                                    const newItems = [
                                      ...values.sales_invoice_products,
                                      { ...salesInvoiceProductValues },
                                    ];
                                    setFieldValue(
                                      "sales_invoice_products",
                                      newItems,
                                    );
                                  }}
                                >
                                  Add Product
                                </button>
                              </div>
                            </>
                          )}
                        </FieldArray>

                        {errors.sales_invoice_products &&
                          touched.sales_invoice_products &&
                          typeof errors.sales_invoice_products === "string" && (
                            <div className="text-danger">
                              {errors.sales_invoice_products}
                            </div>
                          )}
                      </div>
                    </div>

                    <TotalSection
                      values={values}
                      setFieldValue={setFieldValue}
                    />

                    {/* <PackingFields
                      unitList={unitList}
                      packingType={packingType}
                      values={values}
                      handleChange={handleChange}
                      setAddUnitModalStatus={setAddUnitModalStatus}
                      setAddPackingTypeModalStatus={
                        setAddPackingTypeModalStatus
                      }
                      setFieldValue={setFieldValue}
                      calculateWeight={calculateWeight}
                    /> */}

                    <ShipmentFields
                      portList={portList}
                      setAddPortModalStatus={setAddPortModalStatus}
                      values={values}
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      permissions={permissions}
                    />

                    <ContainerFields
                      productList={filteredProductList}
                      permissions={permissions}
                      setAddProductModalStatus={setAddProductModalStatus}
                      setAddSealNumberModalStatus={setAddSealNumberModalStatus}
                      setSelectedSealContainer={setSelectedSealContainer}
                      setFieldValue={setFieldValue}
                      sealNumbersList={sealNumbersList}
                      values={values}
                      noOfContainers={noOfContainers}
                      setNoOfContainers={setNoOfContainers}
                      isShowContainerButton={isShowContainerButton}
                      handleChange={handleChange}
                      setIsShowContainerButton={setIsShowContainerButton}
                    />

                    <MyDocumentsFields
                      documentList={documentList}
                      myDocumentList={myDocumentList}
                      isShowMyDocumentButton={isShowMyDocumentButton}
                      setIsShowMyDocumentButton={setIsShowMyDocumentButton}
                      values={values}
                      handleChange={handleChange}
                      setFieldValue={setFieldValue}
                    />

                    <OtherDocumentsFields
                      actionType={"update"}
                      values={values}
                      documentList={documentList}
                      filePondDocuments={filePondDocuments}
                      setAddDocumentModalStatus={setAddDocumentModalStatus}
                      setFilePondDocuments={setFilePondDocuments}
                      handleFileChange={handleFileChange}
                      setFieldValue={setFieldValue}
                      permissions={permissions}
                    />

                    <BillFields
                      actionType={"update"}
                      values={values}
                      billList={billList}
                      filePondBills={filePondBills}
                      setFilePondBills={setFilePondBills}
                      setAddBillTypeModalStatus={setAddBillTypeModalStatus}
                      handleFileChange={handleFileChange}
                      setFieldValue={setFieldValue}
                    />

                    <SupplierProducts
                      values={values}
                      productList={productList}
                      rowPurchaseOrders={rowPurchaseOrders}
                      setRowPurchaseOrders={setRowPurchaseOrders}
                      supplierList={supplierList}
                      setSupplierList={setSupplierList}
                      supplierProductsQtyData={supplierProductsQtyData}
                      setSupplierProductsQtyData={setSupplierProductsQtyData}
                      unitList={unitList}
                      setFieldValue={setFieldValue}
                      setFieldError={setFieldError}
                      errors={errors}
                    />

                    <ActionFields submitLoader={submitLoader} />
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
      <AddUnitModal
        addUnitModalStatus={addUnitModalStatus}
        closeAddUnitModal={closeAddUnitModal}
        onUnitCreated={fetchInitialData}
      />
      <AddPackingType
        addPackingTypeModalStatus={addPackingTypeModalStatus}
        closePackingTypeModal={closePackingTypeModal}
        onPackingTypeCreated={fetchInitialData}
      />
      <AddProductModal
        addProductModalStatus={addProductModalStatus}
        closeAddProductModal={closeAddProductModal}
        onProductCreated={fetchInitialData}
      />
      <AddDocumentModal
        addDocumentModal={addDocumentModalStatus}
        closeAddDocumentModal={closeAddDocumentModal}
        onDocumentCreated={fetchInitialData}
      />
      <AddLogisticModal
        addLogisticModalStatus={addLogisticModalStatus}
        closeAddLogisticModal={closeAddLogisticModal}
        onLogisticCreated={fetchInitialData}
      />
      <AddChaModal
        addChaModalStatus={addChaModalStatus}
        closeAddChaModal={closeAddChaModal}
        onChaCreated={fetchInitialData}
      />
      <AddNotifyPartyModal
        addNotifyPartyModalStatus={addNotifyPartyModalStatus}
        closeAddNotifyPartyModal={closeAddNotifyPartyModal}
        onNotifyPartyCreated={fetchInitialData}
      />
      <AddPortModal
        addPortModal={addPortModalStatus}
        closeAddPortModal={closeAddPortModal}
        onPortCreated={fetchInitialData}
      />
      <AddBillTypeModal
        addBillTypeModal={addBillTypeModalStatus}
        closeBillTypeModal={closeAddBillTypeModal}
        onBillTypeCreated={fetchInitialData}
      />
      <AddSealNumberModal
        addSealNumberModalStatus={addSealNumberModalStatus}
        closeSealNumberModal={closeAddSealNumberModal}
        onSealNumberCreated={async (newSealNumbers: any) => {
          setSealNumbersList((prev) => [...prev, ...newSealNumbers]);

          if (
            selectedSealContainer.productIndex !== null &&
            selectedSealContainer.containerIndex !== null
          ) {
            await new Promise((r) => setTimeout(r, 0)); // ensures re-render timing
            formikSetFieldValueRef.current?.(
              `container[${selectedSealContainer.containerIndex}].self_seal_id`,
              newSealNumbers[0]?.id,
            );
            setSelectedSealContainer({
              productIndex: null,
              containerIndex: null,
            });
          }
        }}
      />
    </>
  );
};

export default EditSalesInvoice;
